import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface InboxUnreadCountState {
  unreadCount: number;
  nextRefreshAt: number | null;
}

const initialState: InboxUnreadCountState = {
  unreadCount: 0,
  nextRefreshAt: null,
};

const inboxUnreadCountSlice = createSlice({
  name: 'inboxUnreadCount',
  initialState,
  reducers: {
    setUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    setNextRefreshAt: (state, action: PayloadAction<number>) => {
      state.nextRefreshAt = action.payload;
    },
  },
});

export const {
  setUnreadCount: setUnreadCountAction,
  setNextRefreshAt: setNextRefreshAtAction,
} = inboxUnreadCountSlice.actions;

export default inboxUnreadCountSlice.reducer;